var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTsm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 23.53 8.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffc43e;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.27,.12V1.7h-2.15v6.52h-1.97V1.7H0V.12H6.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.6,8.01c-.47-.19-.84-.48-1.12-.85s-.43-.83-.44-1.36h2.1c.03,.3,.13,.53,.31,.69,.18,.16,.41,.24,.69,.24s.52-.07,.69-.2c.17-.13,.25-.32,.25-.56,0-.2-.07-.37-.2-.5-.13-.13-.3-.24-.5-.32-.2-.08-.48-.18-.84-.29-.52-.16-.95-.32-1.28-.49-.33-.16-.62-.4-.85-.71s-.36-.73-.36-1.23c0-.75,.27-1.34,.82-1.77,.55-.43,1.26-.64,2.13-.64s1.61,.21,2.16,.64c.55,.43,.84,1.02,.88,1.78h-2.13c-.02-.26-.11-.47-.29-.62-.18-.15-.4-.23-.68-.23-.24,0-.43,.06-.58,.19-.15,.13-.22,.31-.22,.55,0,.26,.12,.47,.37,.61,.25,.15,.63,.3,1.15,.47,.52,.18,.95,.35,1.27,.51,.33,.16,.61,.4,.85,.7,.24,.31,.36,.71,.36,1.19s-.12,.88-.35,1.26c-.23,.38-.58,.68-1.02,.9-.45,.22-.97,.33-1.58,.33s-1.12-.1-1.59-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.53,.12V8.22h-1.97V3.36l-1.81,4.86h-1.59l-1.82-4.87v4.87h-1.97V.12h2.33l2.27,5.61L21.21,.12h2.32Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTsm);
export default __webpack_public_path__ + "static/media/tsm.823f0ae6a550648e3f57e1ebf26bb8b8.svg";
export { ForwardRef as ReactComponent };